import { ProfesionalPageResponse } from 'src/app/domain/model/profesional/profesional';

/**
 * Puerto (interface) del dominio para operaciones con Profesionales (PPR)
 * 
 * Define el contrato que debe implementar cualquier adaptador
 * de infraestructura (HTTP, Mock, etc.)
 * 
 * Legacy: BusquedaActivity.java con TPSC_PROFESIONALES
 * Usado para tipo de cita SEGUIMIENTO_INTEGRAL_CLIENTE (25)
 * 
 * Consumido desde servicios-ms (no agenda-ms)
 * 
 * @author Emerson Rodriguez - Ingeneo
 */
export abstract class ProfesionalRepository {
  
  /**
   * Busca profesionales con paginación por cursor (keyset pagination, ver
   * skill acceso-datos-oracle §7).
   *
   * <p>El desempate del cursor depende de {@code origen}: NMCONSECUTIVO para
   * PROFESIONALES (maestro PPR), DNI para ORDEN_SERVICIO (default). Un
   * cursor obtenido con un origen no es válido para el otro.</p>
   *
   * @param dni DNI parcial del profesional (opcional)
   * @param nombre Nombre parcial del profesional (opcional)
   * @param cursor Cursor de la página (null = primera página)
   * @param size Tamaño de página
   * @param origen ORDEN_SERVICIO (default) o PROFESIONALES
   * @param direction NEXT | PREVIOUS | LAST
   */
  abstract buscarPaginado(
    dni: string | undefined,
    nombre: string | undefined,
    cursor: string | null,
    size: number,
    origen: string | undefined,
    direction: 'NEXT' | 'PREVIOUS' | 'LAST'
  ): Promise<ProfesionalPageResponse>;
}
